import { render, staticRenderFns } from "./fxl.vue?vue&type=template&id=3b75c3b6&scoped=true&"
import script from "./fxl.vue?vue&type=script&lang=js&"
export * from "./fxl.vue?vue&type=script&lang=js&"
import style0 from "./fxl.vue?vue&type=style&index=0&id=3b75c3b6&lang=less&scoped=true&"
import style1 from "./fxl.vue?vue&type=style&index=1&id=3b75c3b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b75c3b6",
  null
  
)

export default component.exports